import React, { FC } from 'react';

import ProductStatistics from '../ProductStatistics';
import { concreteLoanFormatNameToKey } from '../../../store/loanFormat/actions';
import WarningBadgeList from '../../common/BadgesV2/WarningBadgeList';
import { ProductMetaData } from '../../../../models/Product';

type Props = {
    readonly product: ProductMetaData;
};

const ProductDetailStatistics: FC<Props> = ({ product }) => {
    const productLoanFormatKey = concreteLoanFormatNameToKey(product.loanFormat);
    return (
        <div className="pd-counts">
            <ProductStatistics
                product={product}
                showLabels={true}
                loanFormatKey={productLoanFormatKey}
                placement="bottom-start"
            />
            <WarningBadgeList product={product} />
        </div>
    );
};

export default ProductDetailStatistics;
